/* eslint-disable consistent-return */
import jwtDecode from 'jwt-decode';
import { useSelector } from 'react-redux';
import { selectAuthTokenMyDashboard, selectAuthTokenRefresh, selectAuthTokenAzureAD } from '../store/authToken/selector';

export const useAuth = () => {
  // const myDashboardToken = useSelector(selectAuthTokenMyDashboard);
  // const refreshToken = useSelector(selectAuthTokenRefresh);
  const azureADToken = useSelector(selectAuthTokenAzureAD);
  // const now = Math.floor(Date.now() / 1000);

  try {
    // const { exp }: { exp: number } = jwtDecode(refreshToken);
    // const { exp: expMyDashboard }: { exp: number } = jwtDecode(myDashboardToken);
    const { exp }: { exp: number } = jwtDecode(azureADToken);
    return {
      isRefreshExpired: exp < Date.now() / 1000,
      // isExpiredInOneMinute: expMyDashboard - now <= 60,
    };
  } catch {
    return { isRefreshExpired: false };
  }
};
